/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivePermission,
  ApplicationScope,
  CustomerFinePrints,
  Database,
  DatabaseContentPage,
  DatabaseEntriesCopyRequest,
  DatabaseEntriesCopyResult,
  DatabaseEntry,
  DatabaseEntryComment,
  DatabaseEntryUpdateCreate,
  DatabaseMetaData,
  DatabaseSubDbListItem,
  DatabaseSubDbTable,
  DatabaseUser,
  MailversandErgebnis,
  MailversandRequest,
  MinigolfBahn,
  RankRequest,
  RankResult,
  RecordStatisticRequest,
  SendAsEmailRequest,
  SendEntryEmailRequest,
  WhatsAppLinkResponse,
} from '../models';
import {
    ActivePermissionFromJSON,
    ActivePermissionToJSON,
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CustomerFinePrintsFromJSON,
    CustomerFinePrintsToJSON,
    DatabaseFromJSON,
    DatabaseToJSON,
    DatabaseContentPageFromJSON,
    DatabaseContentPageToJSON,
    DatabaseEntriesCopyRequestFromJSON,
    DatabaseEntriesCopyRequestToJSON,
    DatabaseEntriesCopyResultFromJSON,
    DatabaseEntriesCopyResultToJSON,
    DatabaseEntryFromJSON,
    DatabaseEntryToJSON,
    DatabaseEntryCommentFromJSON,
    DatabaseEntryCommentToJSON,
    DatabaseEntryUpdateCreateFromJSON,
    DatabaseEntryUpdateCreateToJSON,
    DatabaseMetaDataFromJSON,
    DatabaseMetaDataToJSON,
    DatabaseSubDbListItemFromJSON,
    DatabaseSubDbListItemToJSON,
    DatabaseSubDbTableFromJSON,
    DatabaseSubDbTableToJSON,
    DatabaseUserFromJSON,
    DatabaseUserToJSON,
    MailversandErgebnisFromJSON,
    MailversandErgebnisToJSON,
    MailversandRequestFromJSON,
    MailversandRequestToJSON,
    MinigolfBahnFromJSON,
    MinigolfBahnToJSON,
    RankRequestFromJSON,
    RankRequestToJSON,
    RankResultFromJSON,
    RankResultToJSON,
    RecordStatisticRequestFromJSON,
    RecordStatisticRequestToJSON,
    SendAsEmailRequestFromJSON,
    SendAsEmailRequestToJSON,
    SendEntryEmailRequestFromJSON,
    SendEntryEmailRequestToJSON,
    WhatsAppLinkResponseFromJSON,
    WhatsAppLinkResponseToJSON,
} from '../models';

export interface CopyEntriesToDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseEntriesCopyRequest: DatabaseEntriesCopyRequest;
}

export interface CopyEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface CreateEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseEntryUpdateCreate: DatabaseEntryUpdateCreate;
}

export interface CreateEntryCommentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    databaseEntryComment: DatabaseEntryComment;
}

export interface DeleteEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    requestBody?: Array<string>;
}

export interface DeleteEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface DeleteEntryCommentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    commentId: string;
}

export interface ExportDatabaseEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    requestBody?: Array<string>;
}

export interface GetActivePermissionsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetAllDatabasesRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetContentPagesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseIdOrSlug: string;
}

export interface GetDatabaseAttachmentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    attachmentId: string;
}

export interface GetDatabaseDataPrivacyPdfRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseFinePrintsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseImageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseImprintRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseMetaDataRequest {
    xApplicationScope: ApplicationScope;
    databaseIdOrSlug: string;
}

export interface GetDatabaseTermsUsagePdfRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseUsersRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    searchTerm?: string;
    filter?: Array<string>;
    orderBy?: Array<string>;
    belongsTo?: string;
    viaLinkFieldId?: string;
    viaEntryId?: string;
    excludeFields?: Array<string>;
}

export interface GetEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface GetEntryCommentsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface GetFileRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    fieldId: string;
    fileSlug: string;
}

export interface GetHeaderSubDbListEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    blockId: string;
    entryId?: string;
}

export interface GetHeaderSubDbListImageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    blockId: string;
    sourceEntryId: string;
    entryId?: string;
}

export interface GetMinigolfBahnRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId?: string;
    nummer?: number;
}

export interface GetSubDbListBlockEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    pageId: string;
    blockId: string;
    entryId?: string;
}

export interface GetSubDbListBlockImageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    pageId: string;
    blockId: string;
    sourceEntryId: string;
    entryId?: string;
}

export interface GetSubDbTableBlockRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    pageId: string;
    blockId: string;
    entryId?: string;
}

export interface ImportDatabaseEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    body?: Blob;
}

export interface LikeEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface MailversandOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    mailversandRequest: MailversandRequest;
}

export interface PrepareWhatsappLinkRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface RankEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    rankRequest?: RankRequest;
}

export interface RecordStatisticOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    recordStatisticRequest?: RecordStatisticRequest;
}

export interface SendAsEmailOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    sendAsEmailRequest: SendAsEmailRequest;
}

export interface SendEntryEmailOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    sendEntryEmailRequest: SendEntryEmailRequest;
}

export interface SendFieldNotificationsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    fieldId: string;
}

export interface UnlikeEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
}

export interface UpdateEntryRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    databaseEntryUpdateCreate?: DatabaseEntryUpdateCreate;
}

export interface UpdateFieldValueRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    entryId: string;
    fieldId: string;
    body?: object;
}

/**
 * 
 */
export class DatabaseControllerApi extends runtime.BaseAPI {

    /**
     * „Datensaetze kopieren\" (Auftrag 21.10.2026): Einen oder mehrere Datensaetze in eine ANDERE Datenbank kopieren — etwa ein Gericht von einer Speisekarte in die naechste.  ZUORDNUNG wie beim Vorlagenwechsel: erst ueber die Rolle (`templateField`), dann ueber den Feldnamen bei gleichem Feldtyp. Felder ohne Gegenstueck werden NICHT angelegt — das Ziel ist eine bestehende Datenbank, deren Aufbau der Besitzer bestimmt; sie stehen im Ergebnis. Auswahlwerte, die das Ziel nicht kennt, fallen weg und stehen ebenfalls im Ergebnis.  DATEIEN werden mitkopiert (Bilder, Anhaenge, Videos), je Datei in den Ordner des neuen Datensatzes.  UNTERDATENBANK ALS ZIEL: `targetParentEntryId` nennt den Datensatz der Eltern-Datenbank, zu dem die Kopien gehoeren (bei der Speisekarte: die Kategorie). Ohne ihn waeren sie verwaist.  RECHTE: Leserecht an jedem Quell-Datensatz, Schreibrecht am Ziel. 
     * copy database entries into another database including their files
     */
    async copyEntriesToDatabaseRaw(requestParameters: CopyEntriesToDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntriesCopyResult>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling copyEntriesToDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling copyEntriesToDatabase.');
        }

        if (requestParameters.databaseEntriesCopyRequest === null || requestParameters.databaseEntriesCopyRequest === undefined) {
            throw new runtime.RequiredError('databaseEntriesCopyRequest','Required parameter requestParameters.databaseEntriesCopyRequest was null or undefined when calling copyEntriesToDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/copy-entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntriesCopyRequestToJSON(requestParameters.databaseEntriesCopyRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntriesCopyResultFromJSON(jsonValue));
    }

    /**
     * „Datensaetze kopieren\" (Auftrag 21.10.2026): Einen oder mehrere Datensaetze in eine ANDERE Datenbank kopieren — etwa ein Gericht von einer Speisekarte in die naechste.  ZUORDNUNG wie beim Vorlagenwechsel: erst ueber die Rolle (`templateField`), dann ueber den Feldnamen bei gleichem Feldtyp. Felder ohne Gegenstueck werden NICHT angelegt — das Ziel ist eine bestehende Datenbank, deren Aufbau der Besitzer bestimmt; sie stehen im Ergebnis. Auswahlwerte, die das Ziel nicht kennt, fallen weg und stehen ebenfalls im Ergebnis.  DATEIEN werden mitkopiert (Bilder, Anhaenge, Videos), je Datei in den Ordner des neuen Datensatzes.  UNTERDATENBANK ALS ZIEL: `targetParentEntryId` nennt den Datensatz der Eltern-Datenbank, zu dem die Kopien gehoeren (bei der Speisekarte: die Kategorie). Ohne ihn waeren sie verwaist.  RECHTE: Leserecht an jedem Quell-Datensatz, Schreibrecht am Ziel. 
     * copy database entries into another database including their files
     */
    async copyEntriesToDatabase(requestParameters: CopyEntriesToDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntriesCopyResult> {
        const response = await this.copyEntriesToDatabaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Legt eine 1:1-Kopie eines Datensatzes an — samt Anhaengen, Bildern und Videos.  WARUM IM BACKEND UND NICHT IM CLIENT: Die Dateien eines Datensatzes liegen im Speicher unter seiner KENNUNG (`<datenbank>/<datensatz>/`). Ein Client, der nur die Feldwerte kopiert, erzeugt eine Kopie, deren Anhaenge auf den Ordner des Originals zeigen — sie verschwinden, sobald das Original geloescht wird. Der Endpunkt kopiert die Dateien mit.  WAS SICH AENDERT: Laufende Nummern (`SEQUENCE_FIELD`) werden neu vergeben, Berechnungs- und Textbaustein-Felder neu gerechnet, Autor und Zeitstempel sind die des Kopierenden. Alles andere ist identisch, einschliesslich der Zuordnung zu einem uebergeordneten Datensatz (`belongsTo`). 
     * copy a database entry including its files
     */
    async copyEntryRaw(requestParameters: CopyEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling copyEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling copyEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling copyEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/copy`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * Legt eine 1:1-Kopie eines Datensatzes an — samt Anhaengen, Bildern und Videos.  WARUM IM BACKEND UND NICHT IM CLIENT: Die Dateien eines Datensatzes liegen im Speicher unter seiner KENNUNG (`<datenbank>/<datensatz>/`). Ein Client, der nur die Feldwerte kopiert, erzeugt eine Kopie, deren Anhaenge auf den Ordner des Originals zeigen — sie verschwinden, sobald das Original geloescht wird. Der Endpunkt kopiert die Dateien mit.  WAS SICH AENDERT: Laufende Nummern (`SEQUENCE_FIELD`) werden neu vergeben, Berechnungs- und Textbaustein-Felder neu gerechnet, Autor und Zeitstempel sind die des Kopierenden. Alles andere ist identisch, einschliesslich der Zuordnung zu einem uebergeordneten Datensatz (`belongsTo`). 
     * copy a database entry including its files
     */
    async copyEntry(requestParameters: CopyEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.copyEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create an entry
     */
    async createEntryRaw(requestParameters: CreateEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createEntry.');
        }

        if (requestParameters.databaseEntryUpdateCreate === null || requestParameters.databaseEntryUpdateCreate === undefined) {
            throw new runtime.RequiredError('databaseEntryUpdateCreate','Required parameter requestParameters.databaseEntryUpdateCreate was null or undefined when calling createEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryUpdateCreateToJSON(requestParameters.databaseEntryUpdateCreate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * create an entry
     */
    async createEntry(requestParameters: CreateEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.createEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create database entry comment
     * create database entry comment
     */
    async createEntryCommentRaw(requestParameters: CreateEntryCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntryComment>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createEntryComment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createEntryComment.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling createEntryComment.');
        }

        if (requestParameters.databaseEntryComment === null || requestParameters.databaseEntryComment === undefined) {
            throw new runtime.RequiredError('databaseEntryComment','Required parameter requestParameters.databaseEntryComment was null or undefined when calling createEntryComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/comments`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryCommentToJSON(requestParameters.databaseEntryComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryCommentFromJSON(jsonValue));
    }

    /**
     * create database entry comment
     * create database entry comment
     */
    async createEntryComment(requestParameters: CreateEntryCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntryComment> {
        const response = await this.createEntryCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete multiple database entries
     * delete multiple database entries
     */
    async deleteEntriesRaw(requestParameters: DeleteEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * delete multiple database entries
     * delete multiple database entries
     */
    async deleteEntries(requestParameters: DeleteEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.deleteEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete database entry
     * delete database entry
     */
    async deleteEntryRaw(requestParameters: DeleteEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling deleteEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database entry
     * delete database entry
     */
    async deleteEntry(requestParameters: DeleteEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEntryRaw(requestParameters, initOverrides);
    }

    /**
     * delete database entry comment
     * delete database entry comment
     */
    async deleteEntryCommentRaw(requestParameters: DeleteEntryCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteEntryComment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteEntryComment.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling deleteEntryComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling deleteEntryComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/comments/{commentId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database entry comment
     * delete database entry comment
     */
    async deleteEntryComment(requestParameters: DeleteEntryCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEntryCommentRaw(requestParameters, initOverrides);
    }

    /**
     * download database entries with currently applied filter
     * download database entries with currently applied filter
     */
    async exportDatabaseEntriesRaw(requestParameters: ExportDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling exportDatabaseEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling exportDatabaseEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/export-entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * download database entries with currently applied filter
     * download database entries with currently applied filter
     */
    async exportDatabaseEntries(requestParameters: ExportDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportDatabaseEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get active permissions for current user
     * get active permissions for current user
     */
    async getActivePermissionsRaw(requestParameters: GetActivePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivePermission>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getActivePermissions.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getActivePermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/activePermissions`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivePermissionFromJSON(jsonValue));
    }

    /**
     * get active permissions for current user
     * get active permissions for current user
     */
    async getActivePermissions(requestParameters: GetActivePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivePermission> {
        const response = await this.getActivePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all databases
     * get all databases
     */
    async getAllDatabasesRaw(requestParameters: GetAllDatabasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Database>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getAllDatabases.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFromJSON));
    }

    /**
     * get all databases
     * get all databases
     */
    async getAllDatabases(requestParameters: GetAllDatabasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Database>> {
        const response = await this.getAllDatabasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get content pages
     * get content pages
     */
    async getContentPagesRaw(requestParameters: GetContentPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseContentPage>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getContentPages.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getContentPages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/content-pages`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseContentPageFromJSON));
    }

    /**
     * get content pages
     * get content pages
     */
    async getContentPages(requestParameters: GetContentPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseContentPage>> {
        const response = await this.getContentPagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database by id or slug
     * get database by id or slug
     */
    async getDatabaseRaw(requestParameters: GetDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabase.');
        }

        if (requestParameters.databaseIdOrSlug === null || requestParameters.databaseIdOrSlug === undefined) {
            throw new runtime.RequiredError('databaseIdOrSlug','Required parameter requestParameters.databaseIdOrSlug was null or undefined when calling getDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseIdOrSlug}`.replace(`{${"databaseIdOrSlug"}}`, encodeURIComponent(String(requestParameters.databaseIdOrSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * get database by id or slug
     * get database by id or slug
     */
    async getDatabase(requestParameters: GetDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.getDatabaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get database attachment
     * Get database attachment
     */
    async getDatabaseAttachmentRaw(requestParameters: GetDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseAttachment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling getDatabaseAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/attachments/{attachmentId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get database attachment
     * Get database attachment
     */
    async getDatabaseAttachment(requestParameters: GetDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database data privacy pdf
     * get database privacy pdf
     */
    async getDatabaseDataPrivacyPdfRaw(requestParameters: GetDatabaseDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseDataPrivacyPdf.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseDataPrivacyPdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/fine-prints/data-privacy`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database data privacy pdf
     * get database privacy pdf
     */
    async getDatabaseDataPrivacyPdf(requestParameters: GetDatabaseDataPrivacyPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseDataPrivacyPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database fine prints
     * get database fine prints
     */
    async getDatabaseFinePrintsRaw(requestParameters: GetDatabaseFinePrintsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerFinePrints>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseFinePrints.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseFinePrints.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/fine-prints`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFinePrintsFromJSON(jsonValue));
    }

    /**
     * get database fine prints
     * get database fine prints
     */
    async getDatabaseFinePrints(requestParameters: GetDatabaseFinePrintsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerFinePrints> {
        const response = await this.getDatabaseFinePrintsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database image
     * get database image
     */
    async getDatabaseImageRaw(requestParameters: GetDatabaseImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseImage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/image`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database image
     * get database image
     */
    async getDatabaseImage(requestParameters: GetDatabaseImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database imprint
     * get database imprint
     */
    async getDatabaseImprintRaw(requestParameters: GetDatabaseImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseImprint.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseImprint.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/fine-prints/imprint`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * get database imprint
     * get database imprint
     */
    async getDatabaseImprint(requestParameters: GetDatabaseImprintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDatabaseImprintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database meta data by id or slug
     * get database meta data by id or slug
     */
    async getDatabaseMetaDataRaw(requestParameters: GetDatabaseMetaDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseMetaData>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseMetaData.');
        }

        if (requestParameters.databaseIdOrSlug === null || requestParameters.databaseIdOrSlug === undefined) {
            throw new runtime.RequiredError('databaseIdOrSlug','Required parameter requestParameters.databaseIdOrSlug was null or undefined when calling getDatabaseMetaData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/databases/{databaseIdOrSlug}/meta`.replace(`{${"databaseIdOrSlug"}}`, encodeURIComponent(String(requestParameters.databaseIdOrSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseMetaDataFromJSON(jsonValue));
    }

    /**
     * get database meta data by id or slug
     * get database meta data by id or slug
     */
    async getDatabaseMetaData(requestParameters: GetDatabaseMetaDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseMetaData> {
        const response = await this.getDatabaseMetaDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database terms usage pdf
     * get customer terms usage pdf
     */
    async getDatabaseTermsUsagePdfRaw(requestParameters: GetDatabaseTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseTermsUsagePdf.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseTermsUsagePdf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/fine-prints/terms-usage`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database terms usage pdf
     * get customer terms usage pdf
     */
    async getDatabaseTermsUsagePdf(requestParameters: GetDatabaseTermsUsagePdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseTermsUsagePdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all (registererd) users of database
     * get all (registererd) users of database
     */
    async getDatabaseUsersRaw(requestParameters: GetDatabaseUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseUser>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseUsers.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/users`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseUserFromJSON));
    }

    /**
     * get all (registererd) users of database
     * get all (registererd) users of database
     */
    async getDatabaseUsers(requestParameters: GetDatabaseUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseUser>> {
        const response = await this.getDatabaseUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all user entries
     */
    async getEntriesRaw(requestParameters: GetEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEntry>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.searchTerm !== undefined) {
            queryParameters['searchTerm'] = requestParameters.searchTerm;
        }

        if (requestParameters.filter) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.orderBy) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.belongsTo !== undefined) {
            queryParameters['belongsTo'] = requestParameters.belongsTo;
        }

        if (requestParameters.viaLinkFieldId !== undefined) {
            queryParameters['viaLinkFieldId'] = requestParameters.viaLinkFieldId;
        }

        if (requestParameters.viaEntryId !== undefined) {
            queryParameters['viaEntryId'] = requestParameters.viaEntryId;
        }

        if (requestParameters.excludeFields) {
            queryParameters['excludeFields'] = requestParameters.excludeFields;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEntryFromJSON));
    }

    /**
     * get all user entries
     */
    async getEntries(requestParameters: GetEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEntry>> {
        const response = await this.getEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database entry
     * get database entry
     */
    async getEntryRaw(requestParameters: GetEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling getEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * get database entry
     * get database entry
     */
    async getEntry(requestParameters: GetEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.getEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database entry comments
     * get database entry comments
     */
    async getEntryCommentsRaw(requestParameters: GetEntryCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEntryComment>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getEntryComments.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getEntryComments.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling getEntryComments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/comments`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEntryCommentFromJSON));
    }

    /**
     * get database entry comments
     * get database entry comments
     */
    async getEntryComments(requestParameters: GetEntryCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEntryComment>> {
        const response = await this.getEntryCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database entry file
     * get database entry file
     */
    async getFileRaw(requestParameters: GetFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getFile.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getFile.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling getFile.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling getFile.');
        }

        if (requestParameters.fileSlug === null || requestParameters.fileSlug === undefined) {
            throw new runtime.RequiredError('fileSlug','Required parameter requestParameters.fileSlug was null or undefined when calling getFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/{entryId}/{fieldId}/files/{fileSlug}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"fileSlug"}}`, encodeURIComponent(String(requestParameters.fileSlug))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database entry file
     * get database entry file
     */
    async getFile(requestParameters: GetFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Wie der Lesepfad des Seiten-Bausteins, nur dass der Baustein nicht auf einer Seite steht, sondern im Kopf- oder Fussbereich der Datenbank. Gesucht wird in beiden Bereichen; die Kennung des Bausteins genuegt.
     * Datensaetze eines Listen-Bausteins im Kopf- oder Fussbereich
     */
    async getHeaderSubDbListEntriesRaw(requestParameters: GetHeaderSubDbListEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseSubDbListItem>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getHeaderSubDbListEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getHeaderSubDbListEntries.');
        }

        if (requestParameters.blockId === null || requestParameters.blockId === undefined) {
            throw new runtime.RequiredError('blockId','Required parameter requestParameters.blockId was null or undefined when calling getHeaderSubDbListEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/header-blocks/{blockId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"blockId"}}`, encodeURIComponent(String(requestParameters.blockId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseSubDbListItemFromJSON));
    }

    /**
     * Wie der Lesepfad des Seiten-Bausteins, nur dass der Baustein nicht auf einer Seite steht, sondern im Kopf- oder Fussbereich der Datenbank. Gesucht wird in beiden Bereichen; die Kennung des Bausteins genuegt.
     * Datensaetze eines Listen-Bausteins im Kopf- oder Fussbereich
     */
    async getHeaderSubDbListEntries(requestParameters: GetHeaderSubDbListEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseSubDbListItem>> {
        const response = await this.getHeaderSubDbListEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Wie beim Seiten-Baustein: Ausgeliefert wird nur das Feld mit der Rolle „Bild\", und nur von einem Datensatz, den dieser Baustein ohnehin zeigt. Die Dateikennung kommt aus dem Datensatz, nicht aus der Anfrage.
     * Das Bild eines Datensatzes im Kopf- oder Fuss-Listenbaustein
     */
    async getHeaderSubDbListImageRaw(requestParameters: GetHeaderSubDbListImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getHeaderSubDbListImage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getHeaderSubDbListImage.');
        }

        if (requestParameters.blockId === null || requestParameters.blockId === undefined) {
            throw new runtime.RequiredError('blockId','Required parameter requestParameters.blockId was null or undefined when calling getHeaderSubDbListImage.');
        }

        if (requestParameters.sourceEntryId === null || requestParameters.sourceEntryId === undefined) {
            throw new runtime.RequiredError('sourceEntryId','Required parameter requestParameters.sourceEntryId was null or undefined when calling getHeaderSubDbListImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/header-blocks/{blockId}/entries/{sourceEntryId}/image`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"blockId"}}`, encodeURIComponent(String(requestParameters.blockId))).replace(`{${"sourceEntryId"}}`, encodeURIComponent(String(requestParameters.sourceEntryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Wie beim Seiten-Baustein: Ausgeliefert wird nur das Feld mit der Rolle „Bild\", und nur von einem Datensatz, den dieser Baustein ohnehin zeigt. Die Dateikennung kommt aus dem Datensatz, nicht aus der Anfrage.
     * Das Bild eines Datensatzes im Kopf- oder Fuss-Listenbaustein
     */
    async getHeaderSubDbListImage(requestParameters: GetHeaderSubDbListImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getHeaderSubDbListImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert alles, was zu EINER Bahn hinterlegt ist: Bezeichnung, Norm, Form, Abschlag, Ballempfehlungen und Spielweise.  WELCHE BAHN: `nummer`, sonst die aktuelle Bahn der Runde (`entryId`). Fehlt beides, antwortet der Server mit 404.  WARUM EIN EIGENER ENDPUNKT UND NICHT DIE GEWOEHNLICHE LISTE: derselbe Grund wie beim Baustein „Liste aus Unterdatenbank\". Ein anonymer Gast sieht sonst nur seine EIGENEN Datensaetze — seine Runde geht niemanden etwas an. Die Bahnen der Anlage muss er aber lesen koennen, obwohl sie dem Betreiber gehoeren. Die Frage wird deshalb enger gestellt: Der Gast waehlt nicht, WAS er liest, sondern nur WELCHE Bahn; geliefert werden ausschliesslich Felder, denen der Betreiber eine Rolle zugewiesen hat. Ein Feld ohne Rolle verlaesst den Server nicht. 
     * Beschreibung einer Minigolfbahn
     */
    async getMinigolfBahnRaw(requestParameters: GetMinigolfBahnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MinigolfBahn>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMinigolfBahn.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getMinigolfBahn.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        if (requestParameters.nummer !== undefined) {
            queryParameters['nummer'] = requestParameters.nummer;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/minigolf-bahn`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MinigolfBahnFromJSON(jsonValue));
    }

    /**
     * Liefert alles, was zu EINER Bahn hinterlegt ist: Bezeichnung, Norm, Form, Abschlag, Ballempfehlungen und Spielweise.  WELCHE BAHN: `nummer`, sonst die aktuelle Bahn der Runde (`entryId`). Fehlt beides, antwortet der Server mit 404.  WARUM EIN EIGENER ENDPUNKT UND NICHT DIE GEWOEHNLICHE LISTE: derselbe Grund wie beim Baustein „Liste aus Unterdatenbank\". Ein anonymer Gast sieht sonst nur seine EIGENEN Datensaetze — seine Runde geht niemanden etwas an. Die Bahnen der Anlage muss er aber lesen koennen, obwohl sie dem Betreiber gehoeren. Die Frage wird deshalb enger gestellt: Der Gast waehlt nicht, WAS er liest, sondern nur WELCHE Bahn; geliefert werden ausschliesslich Felder, denen der Betreiber eine Rolle zugewiesen hat. Ein Feld ohne Rolle verlaesst den Server nicht. 
     * Beschreibung einer Minigolfbahn
     */
    async getMinigolfBahn(requestParameters: GetMinigolfBahnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MinigolfBahn> {
        const response = await this.getMinigolfBahnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liest die Datensaetze, die dieser Baustein zeigen soll — gefiltert, sortiert, begrenzt, und heruntergebrochen auf die Felder, die der Baustein ueberhaupt anzeigt.  WARUM EIN EIGENER ENDPUNKT UND NICHT DIE GEWOEHNLICHE LISTE:  Ein anonymer Gast sieht sonst nur seine EIGENEN Datensaetze — so soll es sein, seine Runde geht niemanden etwas an. Bahnen und Anzeigen der Anlage muss er aber sehen koennen, obwohl sie dem Betreiber gehoeren.  Der Ausweg ist nicht, dem Gast mehr Rechte zu geben, sondern die Frage enger zu stellen: Die Quelle steht in der SEITE, nicht in der Anfrage. Der Gast kann nicht waehlen, was er liest; er bekommt genau das, was der Baustein zeigt, und nur die Felder, denen der Betreiber eine Rolle zugewiesen hat. Ein Feld ohne Rolle verlaesst den Server nicht. 
     * Datensaetze fuer einen Baustein „Liste aus Unterdatenbank\"
     */
    async getSubDbListBlockEntriesRaw(requestParameters: GetSubDbListBlockEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseSubDbListItem>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getSubDbListBlockEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getSubDbListBlockEntries.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling getSubDbListBlockEntries.');
        }

        if (requestParameters.blockId === null || requestParameters.blockId === undefined) {
            throw new runtime.RequiredError('blockId','Required parameter requestParameters.blockId was null or undefined when calling getSubDbListBlockEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/content-pages/{pageId}/blocks/{blockId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))).replace(`{${"blockId"}}`, encodeURIComponent(String(requestParameters.blockId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseSubDbListItemFromJSON));
    }

    /**
     * Liest die Datensaetze, die dieser Baustein zeigen soll — gefiltert, sortiert, begrenzt, und heruntergebrochen auf die Felder, die der Baustein ueberhaupt anzeigt.  WARUM EIN EIGENER ENDPUNKT UND NICHT DIE GEWOEHNLICHE LISTE:  Ein anonymer Gast sieht sonst nur seine EIGENEN Datensaetze — so soll es sein, seine Runde geht niemanden etwas an. Bahnen und Anzeigen der Anlage muss er aber sehen koennen, obwohl sie dem Betreiber gehoeren.  Der Ausweg ist nicht, dem Gast mehr Rechte zu geben, sondern die Frage enger zu stellen: Die Quelle steht in der SEITE, nicht in der Anfrage. Der Gast kann nicht waehlen, was er liest; er bekommt genau das, was der Baustein zeigt, und nur die Felder, denen der Betreiber eine Rolle zugewiesen hat. Ein Feld ohne Rolle verlaesst den Server nicht. 
     * Datensaetze fuer einen Baustein „Liste aus Unterdatenbank\"
     */
    async getSubDbListBlockEntries(requestParameters: GetSubDbListBlockEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseSubDbListItem>> {
        const response = await this.getSubDbListBlockEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Derselbe Grundsatz wie beim Lesen der Liste: Die Quelle steht in der SEITE. Ausgeliefert wird ausschliesslich das Feld, dem der Betreiber die Rolle „Bild\" zugewiesen hat, und nur von einem Datensatz, den dieser Baustein ohnehin anzeigt.  WARUM NICHT DER GEWOEHNLICHE DATEI-ENDPUNKT: Der prueft den Zugriff auf den DATENSATZ. Ein anonymer Gast darf die Anzeigen der Anlage sehen, aber nicht ihre Datensaetze oeffnen — sonst stuende ihm mit der Datensatz-Kennung die ganze Unterdatenbank offen. 
     * Das Bild eines Datensatzes, den ein Listen-Baustein zeigt
     */
    async getSubDbListBlockImageRaw(requestParameters: GetSubDbListBlockImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getSubDbListBlockImage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getSubDbListBlockImage.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling getSubDbListBlockImage.');
        }

        if (requestParameters.blockId === null || requestParameters.blockId === undefined) {
            throw new runtime.RequiredError('blockId','Required parameter requestParameters.blockId was null or undefined when calling getSubDbListBlockImage.');
        }

        if (requestParameters.sourceEntryId === null || requestParameters.sourceEntryId === undefined) {
            throw new runtime.RequiredError('sourceEntryId','Required parameter requestParameters.sourceEntryId was null or undefined when calling getSubDbListBlockImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/content-pages/{pageId}/blocks/{blockId}/entries/{sourceEntryId}/image`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))).replace(`{${"blockId"}}`, encodeURIComponent(String(requestParameters.blockId))).replace(`{${"sourceEntryId"}}`, encodeURIComponent(String(requestParameters.sourceEntryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Derselbe Grundsatz wie beim Lesen der Liste: Die Quelle steht in der SEITE. Ausgeliefert wird ausschliesslich das Feld, dem der Betreiber die Rolle „Bild\" zugewiesen hat, und nur von einem Datensatz, den dieser Baustein ohnehin anzeigt.  WARUM NICHT DER GEWOEHNLICHE DATEI-ENDPUNKT: Der prueft den Zugriff auf den DATENSATZ. Ein anonymer Gast darf die Anzeigen der Anlage sehen, aber nicht ihre Datensaetze oeffnen — sonst stuende ihm mit der Datensatz-Kennung die ganze Unterdatenbank offen. 
     * Das Bild eines Datensatzes, den ein Listen-Baustein zeigt
     */
    async getSubDbListBlockImage(requestParameters: GetSubDbListBlockImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getSubDbListBlockImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Wie beim Listen-Baustein: Der Aufrufer nennt Seite und Baustein, nicht Datenbank und Feld. Gerechnet wird auf dem Server — Zeilen, Sollwerte und Summen kommen fertig an, die Anzeige faerbt nur noch ein. 
     * Die fertige Tabelle eines Bausteins „Tabelle aus Unterdatenbank\"
     */
    async getSubDbTableBlockRaw(requestParameters: GetSubDbTableBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseSubDbTable>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getSubDbTableBlock.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getSubDbTableBlock.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling getSubDbTableBlock.');
        }

        if (requestParameters.blockId === null || requestParameters.blockId === undefined) {
            throw new runtime.RequiredError('blockId','Required parameter requestParameters.blockId was null or undefined when calling getSubDbTableBlock.');
        }

        const queryParameters: any = {};

        if (requestParameters.entryId !== undefined) {
            queryParameters['entryId'] = requestParameters.entryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/content-pages/{pageId}/blocks/{blockId}/table`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))).replace(`{${"blockId"}}`, encodeURIComponent(String(requestParameters.blockId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseSubDbTableFromJSON(jsonValue));
    }

    /**
     * Wie beim Listen-Baustein: Der Aufrufer nennt Seite und Baustein, nicht Datenbank und Feld. Gerechnet wird auf dem Server — Zeilen, Sollwerte und Summen kommen fertig an, die Anzeige faerbt nur noch ein. 
     * Die fertige Tabelle eines Bausteins „Tabelle aus Unterdatenbank\"
     */
    async getSubDbTableBlock(requestParameters: GetSubDbTableBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseSubDbTable> {
        const response = await this.getSubDbTableBlockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * imports excelfile to database, but only new (no updates)
     * import new database entries
     */
    async importDatabaseEntriesRaw(requestParameters: ImportDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling importDatabaseEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling importDatabaseEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/import-entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * imports excelfile to database, but only new (no updates)
     * import new database entries
     */
    async importDatabaseEntries(requestParameters: ImportDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importDatabaseEntriesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async likeEntryRaw(requestParameters: LikeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling likeEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling likeEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling likeEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/likes`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async likeEntry(requestParameters: LikeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.likeEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verschickt eine Mail-Vorlage der Datenbank an die Adressen der uebergebenen Datensaetze -- je Datensatz eine Mail, mit dessen eigenen Werten in den Platzhaltern. EIN AUFRUF FUER ALLE, nicht einer je Datensatz: Nur so kann das Backend am Ende sagen, wie viele Mails rausgingen und welche nicht -- und nur so laesst sich ein Protokoll ueber den GANZEN Versand erstellen. Bei hundert Einzelaufrufen weiss niemand, wo die Reihe abgebrochen ist.
     */
    async mailversandRaw(requestParameters: MailversandOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailversandErgebnis>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling mailversand.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling mailversand.');
        }

        if (requestParameters.mailversandRequest === null || requestParameters.mailversandRequest === undefined) {
            throw new runtime.RequiredError('mailversandRequest','Required parameter requestParameters.mailversandRequest was null or undefined when calling mailversand.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/mailversand`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailversandRequestToJSON(requestParameters.mailversandRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailversandErgebnisFromJSON(jsonValue));
    }

    /**
     * Verschickt eine Mail-Vorlage der Datenbank an die Adressen der uebergebenen Datensaetze -- je Datensatz eine Mail, mit dessen eigenen Werten in den Platzhaltern. EIN AUFRUF FUER ALLE, nicht einer je Datensatz: Nur so kann das Backend am Ende sagen, wie viele Mails rausgingen und welche nicht -- und nur so laesst sich ein Protokoll ueber den GANZEN Versand erstellen. Bei hundert Einzelaufrufen weiss niemand, wo die Reihe abgebrochen ist.
     */
    async mailversand(requestParameters: MailversandOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailversandErgebnis> {
        const response = await this.mailversandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Looks up the database field mapped to the template-role `phoneWhatsApp`, reads the recipient phone number from the entry, renders the e-card template, converts it to plain text and returns everything the frontend needs to open WhatsApp via wa.me. Also stores a trackingId so the recipient\'s later card view is recorded the same way mail recipients are tracked. 
     * prepare a wa.me Click-to-Chat link for the e-card delivery of this entry
     */
    async prepareWhatsappLinkRaw(requestParameters: PrepareWhatsappLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WhatsAppLinkResponse>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling prepareWhatsappLink.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling prepareWhatsappLink.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling prepareWhatsappLink.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/whatsapp-link`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WhatsAppLinkResponseFromJSON(jsonValue));
    }

    /**
     * Looks up the database field mapped to the template-role `phoneWhatsApp`, reads the recipient phone number from the entry, renders the e-card template, converts it to plain text and returns everything the frontend needs to open WhatsApp via wa.me. Also stores a trackingId so the recipient\'s later card view is recorded the same way mail recipients are tracked. 
     * prepare a wa.me Click-to-Chat link for the e-card delivery of this entry
     */
    async prepareWhatsappLink(requestParameters: PrepareWhatsappLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WhatsAppLinkResponse> {
        const response = await this.prepareWhatsappLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update rank of a database entry
     */
    async rankEntryRaw(requestParameters: RankEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RankResult>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling rankEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling rankEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling rankEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/rank`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RankRequestToJSON(requestParameters.rankRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RankResultFromJSON(jsonValue));
    }

    /**
     * update rank of a database entry
     */
    async rankEntry(requestParameters: RankEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RankResult> {
        const response = await this.rankEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async recordStatisticRaw(requestParameters: RecordStatisticOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling recordStatistic.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling recordStatistic.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling recordStatistic.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/statistics`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordStatisticRequestToJSON(requestParameters.recordStatisticRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async recordStatistic(requestParameters: RecordStatisticOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordStatisticRaw(requestParameters, initOverrides);
    }

    /**
     * send database entry as an email
     */
    async sendAsEmailRaw(requestParameters: SendAsEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendAsEmail.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling sendAsEmail.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling sendAsEmail.');
        }

        if (requestParameters.sendAsEmailRequest === null || requestParameters.sendAsEmailRequest === undefined) {
            throw new runtime.RequiredError('sendAsEmailRequest','Required parameter requestParameters.sendAsEmailRequest was null or undefined when calling sendAsEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/sendAsEmail`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendAsEmailRequestToJSON(requestParameters.sendAsEmailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send database entry as an email
     */
    async sendAsEmail(requestParameters: SendAsEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendAsEmailRaw(requestParameters, initOverrides);
    }

    /**
     * send entry as an email with template
     */
    async sendEntryEmailRaw(requestParameters: SendEntryEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendEntryEmail.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling sendEntryEmail.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling sendEntryEmail.');
        }

        if (requestParameters.sendEntryEmailRequest === null || requestParameters.sendEntryEmailRequest === undefined) {
            throw new runtime.RequiredError('sendEntryEmailRequest','Required parameter requestParameters.sendEntryEmailRequest was null or undefined when calling sendEntryEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/sendEmail`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendEntryEmailRequestToJSON(requestParameters.sendEntryEmailRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send entry as an email with template
     */
    async sendEntryEmail(requestParameters: SendEntryEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendEntryEmailRaw(requestParameters, initOverrides);
    }

    /**
     * send field notifications
     * send field notifications
     */
    async sendFieldNotificationsRaw(requestParameters: SendFieldNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendFieldNotifications.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling sendFieldNotifications.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling sendFieldNotifications.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling sendFieldNotifications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/fields/{fieldId}/sendNotifications`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send field notifications
     * send field notifications
     */
    async sendFieldNotifications(requestParameters: SendFieldNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendFieldNotificationsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async unlikeEntryRaw(requestParameters: UnlikeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling unlikeEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling unlikeEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling unlikeEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/likes`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async unlikeEntry(requestParameters: UnlikeEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.unlikeEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update database entry
     * update database entry
     */
    async updateEntryRaw(requestParameters: UpdateEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateEntry.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateEntry.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling updateEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryUpdateCreateToJSON(requestParameters.databaseEntryUpdateCreate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * update database entry
     * update database entry
     */
    async updateEntry(requestParameters: UpdateEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.updateEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update field value
     * update field value
     */
    async updateFieldValueRaw(requestParameters: UpdateFieldValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateFieldValue.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateFieldValue.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling updateFieldValue.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling updateFieldValue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/databases/{databaseId}/entries/{entryId}/fields/{fieldId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * update field value
     * update field value
     */
    async updateFieldValue(requestParameters: UpdateFieldValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.updateFieldValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
